/* sp-share-ring v2 — 2026-08-03 (v1 + adversarial review fixes)
 * Couple tracking, the missing first mile: a "Send this ring to your person"
 * button on the final-ring view that shares a TOKEN-TAGGED link. The existing
 * pipeline does the rest: sp-track captures ?sref= on the recipient's arrival
 * -> share_opened -> weld_couples() links the pair -> dashboard Couples.
 * v2: share_created only fires when a link actually leaves the device; share-
 * sheet cancel resets quietly (no clipboard clobber); URL built from a
 * whitelist (never forwards the sharer's utm/click-id params); crypto-random
 * tokens; webview fallback shows a copyable field; re-mount survives
 * re-renders. Additive; delete to revert.
 */
(function () {
  'use strict';
  if (window.SPJ_DISABLED) return;
  if (window.__SPJ_SHR__) return;
  window.__SPJ_SHR__ = 1;

  var COLLECT = 'https://zkvdtxlhzucquktwyrjw.supabase.co/functions/v1/collect';
  var AUTH = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InprdmR0eGxoenVjcXVrdHd5cmp3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODUzMzcwODMsImV4cCI6MjEwMDkxMzA4M30.T6p6Z4_URBOQHm8kLZXEhVUEf_xAZUk2_t7HpYI1shg';
  var WRITE_KEY = 'sjp_wk_9f27c1e84ab35d60';

  function visitorId() {
    var m = document.cookie.match(/(?:^|;\s*)_shopify_y=([^;]+)/);
    if (m) return decodeURIComponent(m[1]).slice(0, 64);
    try { return localStorage.getItem('spj_vid') || null; } catch (err) { return null; }
  }

  function consentOk() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed() !== false;
    } catch (err) {}
    return true;
  }

  function track(name, props) {
    if (!consentOk()) return;
    try {
      fetch(COLLECT, {
        method: 'POST',
        keepalive: true,
        headers: { 'content-type': 'application/json', 'Authorization': AUTH },
        body: JSON.stringify({
          k: WRITE_KEY,
          events: [{ event_id: (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : null, ts: Date.now(), visitor_id: visitorId(), name: name, source: 'theme', page_type: 'final_ring', page_path: location.pathname + location.search, props: props || {} }]
        })
      }).catch(function () {});
    } catch (err) {}
  }

  function mintToken() {
    try {
      var a = new Uint8Array(10);
      crypto.getRandomValues(a);
      return 'sh' + Array.prototype.map.call(a, function (b) { return (b % 36).toString(36); }).join('');
    } catch (err) {
      return 'sh' + Date.now().toString(36) + Math.floor(Math.random() * 1e6).toString(36);
    }
  }

  function taggedUrl(tok) {
    // whitelist rebuild — never forward the sharer's utm/click-id/_kx params
    var q = {};
    location.search.slice(1).split('&').forEach(function (kv) {
      var p = kv.split('=');
      q[decodeURIComponent(p[0] || '')] = decodeURIComponent(p[1] || '');
    });
    var u = new URL(location.origin + location.pathname);
    ['view', 'sku', 'variant', 'size'].forEach(function (k) { if (q[k]) u.searchParams.set(k, q[k]); });
    u.searchParams.set('sref', tok);
    return u.toString();
  }

  function skuFromUrl() {
    var m = location.search.match(/[?&]sku=([^&]+)/);
    return m ? decodeURIComponent(m[1]).slice(0, 64) : null;
  }

  function sharedOk(tok, channel) {
    // fire only when a link actually left the device — keeps couples clean
    track('share_created', { token: tok, channel: channel, handle: location.pathname.split('/')[2] || null, sku: skuFromUrl() });
  }

  // public hook: lets the site's own share controls (Share Cart) mint a
  // couple-token and log share_created without duplicating collector logic.
  // Returns the token to append as &sref=<tok>. Null-guarded at call sites.
  window.__spjMintShare = function (channel, extraProps) {
    var tok = mintToken();
    var props = { token: tok, channel: String(channel || 'site_share').slice(0, 32), handle: location.pathname.split('/')[2] || null, sku: skuFromUrl() };
    if (extraProps && typeof extraProps === 'object') {
      for (var k in extraProps) {
        if (Object.prototype.hasOwnProperty.call(extraProps, k)) props[k] = extraProps[k];
      }
    }
    track('share_created', props);
    return tok;
  };

  // everything below is the parked final-ring button — page-scoped
  if (location.search.indexOf('view=final-ring') === -1) return;

  function mount() {
    var atc = document.getElementById('addToCart');
    if (!atc || document.querySelector('.spj-shr')) return;
    var host = atc.closest('.product-form__add-to-setting') || atc.parentElement;
    if (!host || !host.parentNode) return;

    if (!document.getElementById('spj-shr-css')) {
      var css = document.createElement('style');
      css.id = 'spj-shr-css';
      css.textContent =
        '.spj-shr{display:block;width:100%;margin-top:10px;padding:12px 14px;border:1px solid #0A1D2E;border-radius:6px;background:#fff;color:#0A1D2E;font-size:14px;font-weight:600;cursor:pointer;text-align:center}' +
        '.spj-shr:active{background:#f4f6f8}' +
        '.spj-shr-fld{display:flex;gap:6px;margin-top:8px}' +
        '.spj-shr-fld input{flex:1;min-width:0;border:1px solid #cfd5db;border-radius:6px;padding:9px 11px;font-size:13px;color:#0A1D2E;background:#fff}';
      document.head.appendChild(css);
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'spj-shr';
    btn.textContent = 'Send this ring to your person';
    host.parentNode.insertBefore(btn, host.nextSibling);

    var busy = false;
    var reset = function (label, ms) {
      btn.textContent = label;
      setTimeout(function () { btn.textContent = 'Send this ring to your person'; busy = false; }, ms || 2600);
    };
    var showField = function (url) {
      // last resort (in-app webviews without share/clipboard): a real copyable field
      var old = btn.parentNode.querySelector('.spj-shr-fld');
      if (old) old.remove();
      var wrap = document.createElement('div');
      wrap.className = 'spj-shr-fld';
      wrap.innerHTML = '<input type="text" readonly aria-label="Ring link">';
      var inp = wrap.querySelector('input');
      inp.value = url;
      btn.parentNode.insertBefore(wrap, btn.nextSibling);
      inp.focus();
      inp.select();
      try { document.execCommand('copy'); reset('Link copied — send it!'); } catch (err) { reset('Copy the link below', 4000); }
    };

    btn.addEventListener('click', function () {
      if (busy) return;
      busy = true;
      var safety = setTimeout(function () { busy = false; btn.textContent = 'Send this ring to your person'; }, 8000);
      var tok = mintToken();
      var url = taggedUrl(tok);

      if (navigator.share) {
        navigator.share({ title: 'Look at this ring', url: url })
          .then(function () { clearTimeout(safety); sharedOk(tok, 'native_share'); reset('Sent ✓'); })
          .catch(function (err) {
            clearTimeout(safety);
            if (err && err.name === 'AbortError') { busy = false; btn.textContent = 'Send this ring to your person'; return; }
            // real failure — try clipboard, then the visible field
            try {
              navigator.clipboard.writeText(url).then(
                function () { sharedOk(tok, 'copy_link'); reset('Link copied — send it!'); },
                function () { sharedOk(tok, 'copy_field'); showField(url); }
              );
            } catch (e2) { sharedOk(tok, 'copy_field'); showField(url); }
          });
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(
          function () { clearTimeout(safety); sharedOk(tok, 'copy_link'); reset('Link copied — send it!'); },
          function () { clearTimeout(safety); sharedOk(tok, 'copy_field'); showField(url); }
        );
      } else {
        clearTimeout(safety);
        sharedOk(tok, 'copy_field');
        showField(url);
      }
    });
  }

  // BUTTON PARKED 8/03 by owner — "overwhelming on step 3"; owner will pick
  // the placement. All machinery stays ready: to re-enable, restore the two
  // lines below. (Tagged hint-links, sref capture, weld, dashboard unaffected.)
  // mount();
  // setInterval(mount, 2500);
})();
